import React, {useState} from 'react'
import {useDispatch} from 'react-redux'

import {PopupBox} from '../../components/popups/PopupBox'
import {Cross} from '../../components/UI/Cross'
import {PrimaryButton} from '../../components/UI/PrimaryButton'
import {CreateCategory} from './CreateCategory'
import {ChangeCategory} from './ChangeCategories'

import {CategoriesSettingsContainer} from './styled_components'

export const CategoriesSettings = () => {
    const dispatch = useDispatch()
    const [activeBlock, setActiveBlock] = useState('')

    return (
        <CategoriesSettingsContainer>
            <PopupBox className='popup-box'>
                <div className='' onClick={() => dispatch({type: 'CHANGE_CATEGORIES_CLOSED'})}><Cross lighten/></div>
                <p className="title">Создание и редактирование категорий</p>

                {!activeBlock
                    ? <div className="choose-action">
                        <PrimaryButton onClick={() => setActiveBlock('create')} className='choose-button' lighten>Создать
                            категорию</PrimaryButton>
                        <PrimaryButton onClick={() => setActiveBlock('change')} className='choose-button' lighten>Редактировать
                            категорию</PrimaryButton>
                    </div>
                    : activeBlock === 'create'
                        ? <CreateCategory go_back={setActiveBlock}/>
                        : <ChangeCategory go_back={setActiveBlock}/>
                }

            </PopupBox>
        </CategoriesSettingsContainer>
    )
}
